import React, { FC } from 'react';
import { InputNumber as RawInputNumber } from 'components/atoms/input';
import { withStylePreferenceConsumer } from 'components/atoms/style-preference-context';
import { NumberField } from '../fields';
import { EditableProps } from './editable-props';
import { NoValue } from './no-value';

interface Props extends Partial<EditableProps<number>> {
  field: NumberField;
}

const InputNumber = withStylePreferenceConsumer(RawInputNumber);

export const NumberFieldValue: FC<Props> = ({
  field,
  id,
  editable,
  onChange,
  onKeyDown,
}) =>
  !editable ? (
    field.value == null ? (
      <NoValue />
    ) : (
      <>{field.value}</>
    )
  ) : (
    <InputNumber
      id={id}
      autoFocus
      data-cy={`ag-grid.${field.type}.editor`}
      value={field.value}
      min={field.metaData?.range?.min}
      max={field.metaData?.range?.max}
      onChange={(latest) => onChange?.(latest as number)}
      onKeyDown={onKeyDown}
    />
  );
